import type { FC } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { useLinkComponent } from '@eneco/link';
import { MessageBar as SparkyMessageBar } from '@eneco/sparky';
import { MessageBarRendering } from '@sitecore/types/manual/MessageBar';

const MessageBar: FC<MessageBarRendering> = ({ fields: { title, content, link }, params }) => {
  const Link = useLinkComponent();

  return (
    <Link editable={link.editable} linkType={link.value.linktype} linkValue={link.value}>
      <SparkyMessageBar
        headingLevel={params?.headingLevel}
        text={<RichText html={content.value} />}
        title={title.value}
      />
    </Link>
  );
};

export { MessageBar };
export default MessageBar;
